export default __webpack_public_path__ + "static/media/FitnessVideos.9ba57e76.jpg";